import React from "react";
import {QuestionOptions} from "./QuestionOptions";

export function ImageQuestion(props) {


    if(props.question != null) {

        return(
            <div className={"d-flex flex-column justify-content-center align-content-center m-0 px-3"}>

                <div className={"row"}>
                    <div className={"col  p-4"}>
                        {/*<QuestionTags question={props.question}/>*/}
                        <h3 className={"mt-3 border-bottom pb-3"}>{props.question.text}</h3>

                        <QuestionOptions options={props.question.options} disabled={props.disabled} displayAnswers={props.displayAnswers} nextQuestionCallback={props.nextQuestionCallback} multipleChoice={props.question.multipleChoice} selectOptionCallback={props.selectOptionCallback}/>


                    </div>

                    <div className={"col d-flex justify-content-center align-items-center"}>
                        <img src={props.question.image.url} className={"rounded p-0 m-0  w-100"} />
                    </div>
                </div>





            </div>
        );
    }

}